import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

type StartPettyWorkModalProps = {
  show: boolean;
  pettyWorkLabel?: string;
  busy?: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
};

const StartPettyWorkModal = ({
  show,
  pettyWorkLabel,
  busy = false,
  onClose,
  onConfirm,
}: StartPettyWorkModalProps) => {
  return (
    <Modal isOpen={show} toggle={() => !busy && onClose()} centered>
      <ModalHeader toggle={() => !busy && onClose()}>
        Start petty work
      </ModalHeader>
      <ModalBody className="text-center px-4 pt-2 pb-2">
        <i
          className="ri-play-circle-line display-4 text-primary d-block mb-3"
          aria-hidden
        />
        <p className="text-muted mb-0">
          {pettyWorkLabel ? (
            <>
              <span className="fw-medium">{pettyWorkLabel}</span>
              {" — "}
            </>
          ) : null}
          This will mark the petty work as{" "}
          <span className="fw-medium">In progress</span>.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="light" type="button" onClick={onClose} disabled={busy}>
          Back
        </Button>
        <Button
          color="primary"
          type="button"
          onClick={() => void onConfirm()}
          disabled={busy}
        >
          {busy ? "Starting..." : "Start work"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default StartPettyWorkModal;
